module.exports = __webpack_public_path__ + "static/img/city_top.b1d92b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city_top.jpg
// module id = FZF5
// module chunks = 80